<template>
  <v-container class="py-10 px-8">
    <!-- Encabezado -->
    <div>
      <v-btn @click="$router.go(-1)" text class="pl-0">
        <v-icon class="mr-1" size="15px"> mdi-arrow-left </v-icon>
        <span class="text-return mon-regular" style="font-family: 'montserrat-medium';">{{ "Regresar" }}</span>
      </v-btn>
    </div>
    <v-row>
      <v-col cols="12">
        <h2 class="display-1 font-weight-bold">Reporte Persona Física</h2>
      </v-col>
    </v-row>

    <v-row class="mt-4" dense>
      <v-col cols="12" md="6" class="pa-3">
        <v-card style="border-radius: 16px;" class="mb-4">
          <h3 class="mb-3 px-4 py-2 white--text" style="background-color: black; font-family: 'montserrat-bold';">
            <v-icon left color="white">mdi-magnify</v-icon> Datos de Entrada
          </h3>
          <div class="pa-4">
            <div><strong>Nombre(s):</strong> {{ data.nombres }}</div>
            <div><strong>Apellido Paterno:</strong> {{ data.apellido_paterno }}</div>
            <div><strong>Apellido Materno:</strong> {{ data.apellido_materno }}</div>
            <div><strong>Estado de Nacimiento:</strong> {{ data.estado_nacimiento }}</div>
            <div><strong>Fecha de Nacimiento:</strong> {{ formatDate(data.fecha_nacimiento) }}</div>
            <div><strong>Correo Electrónico:</strong> {{ data.correo_electronico }}</div>
            <div><strong>Número telefónico:</strong> {{ data.phone }}</div>
            <div><strong>Sexo:</strong> {{ data.sexo }}</div>
            <div><strong>RFC:</strong> {{ data.rfc }}</div>
            <div><strong>CURP:</strong> {{ data.curp }}</div>
          </div>
        </v-card>
        <v-card style="border-radius: 16px;" class="mb-4">
          <h3 class="mb-3 px-4 py-2 white--text" style="background-color: black; font-family: 'montserrat-bold';">
            <v-icon left color="white">mdi-clock-outline</v-icon> Información del reporte
          </h3>
          <div class="pa-4">
            <div><strong>Fecha y Hora de Búsqueda:</strong> {{ formatDate(data.created_at) }}</div>
            <div><strong>No. de Reporte:</strong> {{ data.sId }}</div>
            <div><strong>Estatus:</strong> {{ data.status }}</div>
          </div>
        </v-card>
        <div>
          <p class="font-weight-medium mb-2">¿Quieres descargar tu reporte? Aquí puedes hacerlo.</p>
          <v-btn disabled rounded color="primary" class="mr-2" outlined>
            <v-icon left>mdi-download</v-icon> Descargar Reporte
          </v-btn>
        </div>
      </v-col>
      <v-col cols="12" md="6" class="pa-3">
        <v-card class="rounded-xl elevation-5" color="white" style="height: 400px; overflow-y: auto;">
          <h3 class="mb-3 px-4 py-2 white--text" style="background-color: black; font-family: 'montserrat-bold';">
            <v-icon left color="white">mdi-robot</v-icon> Análisis del Reporte
          </h3>

          <v-card-text class="text-center" style="height: 400px; overflow-y: auto;">
            <div v-if="analysis" class="text--darken-3" style="white-space: pre-line; text-align: left; font-family: 'montserrat-semibold';">
              {{ analysis }}
            </div>

            <div v-else>
              <p class="mb-4 grey--text">
                Haz clic en el botón para generar un análisis con IA del reporte.
              </p>

              <v-btn
                :loading="loading"
                :disabled="loading"
                @click="analyzeWithAI"
                class="white--text font-weight-bold"
                style="background: linear-gradient(135deg, #00c6ff, #6b00b6);"
                rounded
                large
              >
                <span v-if="!loading" style="font-family: 'montserrat-bold';">Analizar con IA ✨</span>
                <span v-else>Cargando...</span>
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-expansion-panels multiple class="mt-8">
     <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
        <v-expansion-panel-header class="panel-header">
          VALIDACIÓN DE IDENTIDAD
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-expansion-panels multiple class="mt-8">
            <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
              <v-expansion-panel-header class="panel-header">
                CURP (Clave Única de Registro de Población)
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div v-if="data?.data?.curp?.data?.curpdata.length">
                  <v-list dense>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title><strong>CURP:</strong> {{ data?.data?.curp?.data?.curpdata[0]?.curp }}</v-list-item-title>
                        <v-list-item-subtitle>
                          <strong>Nombre:</strong> {{ data?.data?.curp?.data?.curpdata[0]?.nombres }} {{ data?.data?.curp?.data?.curpdata[0]?.primerApellido }} {{ data?.data?.curp?.data?.curpdata[0]?.segundoApellido }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle>
                          <strong>Fecha de nacimiento:</strong> {{ data?.data?.curp?.data?.curpdata[0]?.fechaNacimiento }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle>
                          <strong>Sexo:</strong> {{ data?.data?.curp?.data?.curpdata[0]?.sexo }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle>
                          <strong>Entidad:</strong> {{ data?.data?.curp?.data?.curpdata[0]?.entidad }} ({{ data?.data?.curp?.data?.curpdata[0]?.claveEntidad }})
                        </v-list-item-subtitle>
                        <v-list-item-subtitle>
                          <strong>Nacionalidad:</strong> {{ data?.data?.curp?.data?.curpdata[0]?.nacionalidad }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle>
                          <strong>Estatus CURP:</strong> {{ data?.data?.curp?.data?.curpdata[0]?.statusCurp }} - {{ data?.data?.curp?.data?.curpdata[0]?.descriptionStatusCurp }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>

                <div v-else>
                  <p>Sin coincidencias encontradas.</p>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
              <v-expansion-panel-header class="panel-header">
                Registro Federal de Contribuyentes (RFC)
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="d-flex" style="font-family: 'montserrat-semibold';">
                  <div style="width: 100%;">
                    <h3 class="mb-1 mt-4" style="font-family: 'montserrat-bold';">RFC (Registro Federal de Contribuyentes)</h3>
                    <v-divider class="my-2"></v-divider>
                    <p class="mb-0"><strong style="font-family: 'montserrat-bold';">Resultado:</strong> {{ data?.data?.validacionEmpresa?.data?.estatus }}</p>
                    <p class="mb-0"><strong style="font-family: 'montserrat-bold';">RFC:</strong> {{ data?.data?.certificadosSAT?.data?.rfc }}</p>
                    <p><strong style="font-family: 'montserrat-bold';">Razón Social:</strong> {{ data?.data?.certificadosSAT?.data?.razon_social }}</p>
                  </div>
                </div>

                <div class="mt-6">
                  <h4 style="font-family: 'montserrat-medium';">Documentos:</h4>
                  <div style="max-height: 400px; overflow-y: auto;">
                    <v-row class="pa-4">
                      <v-col
                        v-for="(cert, index) in data?.data?.certificadosSAT?.data?.certificados"
                        :key="index"
                        cols="12"
                        md="6"
                        lg="4"
                      >
                        <v-card class="pa-4" style="border-radius: 12px; font-family: 'montserrat-medium';" elevation="5">
                          <p><strong>Número de Serie:</strong> {{ cert.numero_serie }}</p>
                          <p><strong>Estado:</strong> {{ cert.estado }}</p>
                          <p><strong>Tipo:</strong> {{ cert.tipo }}</p>
                          <p><strong>Fecha Inicial:</strong> {{ formatDate(cert.fecha_inicio) }}</p>
                          <p><strong>Fecha Final:</strong> {{ formatDate(cert.fecha_fin) }}</p>
                          <v-btn
                            v-if="cert.certificado"
                            color="primary"
                            class="mt-2"
                            rounded
                            @click="downloadCertificate(cert.certificado, cert.numero_serie)"
                            outlined
                          >
                            <v-icon left>mdi-file-download</v-icon>
                            Descargar .Cer
                          </v-btn>
                        </v-card>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
              <v-expansion-panel-header class="panel-header">
                Registro Público de Comercio (SIGER)
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-container fluid>
                  <v-row>
                    <v-col cols="12" md="6">
                      <p><strong>Razón Social:</strong> {{ data?.data?.SIGER?.data[0]?.razon_social }}</p>
                      <p><strong>Duración de la Sociedad:</strong> {{ data?.data?.SIGER?.data[0]?.duracion_sociedad }}</p>
                      <p><strong>Domicilio Social:</strong> {{ data?.data?.SIGER?.data[0]?.domicilio_social }}</p>
                      <p><strong>Nacionalidad:</strong> {{ data?.data?.SIGER?.data[0]?.nacionalidad }}</p>
                      <p><strong>RFC:</strong> {{ data?.data?.SIGER?.data[0]?.rfc || 'No disponible' }}</p>
                      <p><strong>Tipo de Persona:</strong> {{ data?.data?.SIGER?.data[0]?.tipo_persona }}</p>
                      <p><strong>Regimen Jurídico:</strong> {{ data?.data?.SIGER?.data[0]?.regimen_juridico }}</p>
                      <p><strong>Fecha de inscripción:</strong> {{ data?.data?.SIGER?.data[0]?.fecha_incripcion }}</p>
                      <p><strong>Entidad Federativa:</strong> {{ data?.data?.SIGER?.data[0]?.entidad_federativa }}</p>
                      <p><strong>Municipio:</strong> {{ data?.data?.SIGER?.data[0]?.municipio }}</p>
                      <p><strong>Oficina Registral:</strong> {{ data?.data?.SIGER?.data[0]?.oficina_registral }}</p>
                    </v-col>

                    <v-col cols="12" md="6">
                      <p><strong>Objeto Social:</strong></p>
                      <div style="max-height: 250px; overflow-y: auto; background-color: #f5f5f5; padding: 1rem; border-radius: 8px;">
                        <pre style="white-space: pre-wrap;">{{ data?.data?.SIGER?.data[0]?.objeto_social }}</pre>
                      </div>
                    </v-col>
                  </v-row>

                  <v-divider class="my-4" />

                  <h3 class="text-h6 font-weight-bold mb-2">Socios ({{ data?.data?.SIGER?.data[0]?.numero_socios || 0 }})</h3>

                  <v-row v-if="data?.data?.SIGER?.data[0]?.nombre_socios && data?.data?.SIGER?.data[0]?.nombre_socios?.length">
                    <v-col
                      v-for="(socio, index) in data?.data?.SIGER?.data[0]?.nombre_socios"
                      :key="index"
                      cols="12"
                      md="6"
                    >
                      <v-card outlined class="pa-3 mb-3">
                        <p><strong>Nombre:</strong> {{ socio.nombre }} {{ socio.apellido_paterno }} {{ socio.apellido_materno }}</p>
                        <p><strong>RFC:</strong> {{ socio.rfc }}</p>
                        <p><strong>CURP:</strong> {{ socio.curp }}</p>
                        <p><strong>Nacionalidad:</strong> {{ socio.nacionalidad }}</p>
                        <p><strong>Estado:</strong> {{ socio.estatus }}</p>
                        <p><strong>Fecha de nacimiento:</strong> {{ socio.fecha_nacimiento || 'N/D' }}</p>
                        <p><strong>Acciones:</strong> {{ socio.acciones }}</p>
                        <p><strong>Total:</strong> {{ socio.total }}</p>
                        <p><strong>Valor:</strong> {{ socio.valor }}</p>
                      </v-card>
                    </v-col>
                  </v-row>

                  <v-row v-else>
                    <v-col cols="12">
                      <p>No se encontraron socios registrados.</p>
                    </v-col>
                  </v-row>
                </v-container>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
              <v-expansion-panel-header class="panel-header">
                Registro Nacional de Profesiones
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div v-if="data?.data?.cedula?.data?.length">
                  <v-container fluid>
                    <v-row dense>
                      <v-col
                        v-for="(profesion, index) in data?.data?.cedula?.data"
                        :key="index"
                        cols="12"
                        md="6"
                        class="pa-2"
                      >
                        <v-card style="border-radius: 12px;" outlined class="mb-3" elevation="4">
                          <v-card-title >
                            {{ profesion.profesion }}
                          </v-card-title>
                          <v-card-subtitle class="grey--text">
                            Cédula: {{ profesion.numCedula }}
                          </v-card-subtitle>
                          <v-card-text>
                            <div><strong>Nombre:</strong> {{ profesion.nombre }}</div>
                            <div><strong>Institución:</strong> {{ profesion.institucion }}</div>
                            <div><strong>Año de registro:</strong> {{ profesion.fechaRegistro }}</div>
                            <div><strong>Tipo:</strong> {{ profesion.tipo }}</div>
                            <div><strong>Género:</strong> {{ profesion.genero }}</div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>
                </div>
                <div v-else>
                  <p>Sin coincidencias encontradas.</p>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>

          </v-expansion-panels>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
        <v-expansion-panel-header class="panel-header">
          LISTAS NEGRAS
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-expansion-panels multiple class="mt-8">
            <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
              <v-expansion-panel-header class="panel-header">
                LISTAS NEGRAS INTERNACIONALES
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div v-if="data?.data?.listasNegras?.data?.has_crimelist_match">
                  <v-alert type="error" outlined class="mb-3">⚠️ Coincidencia en lista criminal</v-alert>
                </div>


                <div v-if="data?.data?.listasNegras?.data?.has_watchlist_match">
                  <v-alert type="warning" outlined class="mb-3">🔍 Coincidencia en lista de vigilancia</v-alert>
                </div>


                <div v-if="data?.data?.listasNegras?.data?.has_pep_match">
                  <v-alert type="warning" outlined class="mb-3">👔 Coincidencia con persona políticamente expuesta (PEP)</v-alert>
                </div>


                <div v-if="data?.data?.listasNegras?.data?.has_sanction_match && data?.data?.listasNegras?.data?.result_payload?.sanctionlist_entries?.length">
                  <v-alert type="error" outlined class="mb-3">🚫 Coincidencia en lista de sanciones</v-alert>

                  <v-card
                    v-for="(entry, i) in data?.data?.listasNegras?.data?.result_payload?.sanctionlist_entries"
                    :key="i"
                    class="mb-4"
                    outlined
                  >
                    <v-card-title class="headline">{{ entry.name }}</v-card-title>
                    <v-card-subtitle>{{ entry.birth_date }} — {{ entry.birth_place }}</v-card-subtitle>

                    <v-card-text>
                      <p><strong>Programa:</strong> {{ entry.program }}</p>
                      <p><strong>ID:</strong> {{ entry.id_number }} ({{ entry.id_type }})</p>

                      <div v-if="entry.akas && entry.akas.length">
                        <p><strong>Alias:</strong></p>
                        <ul>
                          <li v-for="(aka, j) in entry.akas" :key="j">{{ aka.name }} ({{ aka.type }})</li>
                        </ul>
                      </div>

                      <div v-if="entry.attributes && entry.attributes.length">
                        <p><strong>Atributos:</strong></p>
                        <ul>
                          <li v-for="(attr, k) in entry.attributes" :key="k">
                            {{ attr.key }}: {{ attr.value }}
                          </li>
                        </ul>
                      </div>
                    </v-card-text>
                  </v-card>
                </div>
                <div v-else>
                  <p>Sin coincidencias encontradas.</p>
                </div> 
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
              <v-expansion-panel-header class="panel-header">
                SAT 69 Contribuyentes No Localizados
              </v-expansion-panel-header>
             <v-expansion-panel-content>
                <template v-if="data?.data?.sat69?.data.length">
                  <v-row dense v-for="(contribuyente, index) in data?.data?.sat69?.data" :key="index" class="mb-3">
                    <v-col cols="12">
                      <v-card outlined class="pa-4">
                        <p><strong>RFC:</strong> {{ contribuyente.rfc.toUpperCase() }}</p>
                        <p><strong>Razón Social:</strong> {{ contribuyente.razon_social }}</p>
                        <p><strong>Tipo de Persona:</strong> {{ contribuyente.tipo_persona === 'm' ? 'Moral' : 'Física' }}</p>
                        <p><strong>Supuesto:</strong> {{ contribuyente.supuesto }}</p>
                        <p><strong>Primera Publicación:</strong> {{ contribuyente.fecha_primera_publicacion }}</p>
                        <p><strong>Entidad Federativa:</strong> {{ contribuyente.entidad_federativa }}</p>
                      </v-card>
                    </v-col>
                  </v-row>
                </template>

                <template v-else>
                  <p>Sin coincidencias encontradas.</p>
                </template>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
              <v-expansion-panel-header class="panel-header">
                SAT 69B Contribuyentes Boletinados
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <template v-if="data?.data?.sat69B?.data?.length">
                  <v-row dense v-for="(contribuyente, index) in data?.data?.sat69B?.data" :key="index" class="mb-3">
                    <v-col cols="12">
                      <v-card outlined class="pa-4">
                        <p><strong>RFC:</strong> {{ contribuyente.rfc }}</p>
                        <p><strong>Nombre:</strong> {{ contribuyente.nombre_contribuyente }}</p>
                        <p><strong>Situación:</strong> {{ contribuyente.situacion_contribuyente }}</p>

                        <p class="mt-2"><strong>Presunción:</strong></p>
                        <ul>
                          <li><strong>Oficio Global:</strong> {{ contribuyente.fecha_oficio_global_presuncion }}</li>
                          <li><strong>Publicación SAT:</strong> {{ contribuyente.fecha_publi_sat_presuntos }}</li>
                          <li><strong>Publicación DOF:</strong> {{ contribuyente.fecha_publi_dof_presuntos }}</li>
                        </ul>

                        <p class="mt-2"><strong>Desvirtuados:</strong></p>
                        <ul>
                          <li><strong>Publicación SAT:</strong> {{ contribuyente.fecha_publi_sat_desvirtuados || 'N/A' }}</li>
                          <li><strong>Oficio Global:</strong> {{ contribuyente.fecha_oficio_global_desvirtuaron || 'N/A' }}</li>
                          <li><strong>Publicación DOF:</strong> {{ contribuyente.fecha_publi_dof_desvirtuaron || 'N/A' }}</li>
                        </ul>

                        <p class="mt-2"><strong>Definitivos:</strong></p>
                        <ul>
                          <li><strong>Oficio Global:</strong> {{ contribuyente.fecha_oficio_global_definitivos || 'N/A' }}</li>
                          <li><strong>Publicación SAT:</strong> {{ contribuyente.fecha_publi_sat_definitivos || 'N/A' }}</li>
                          <li><strong>Publicación DOF:</strong> {{ contribuyente.fecha_publi_dof_definitivos || 'N/A' }}</li>
                        </ul>

                        <p class="mt-2"><strong>Favorable:</strong></p>
                        <ul>
                          <li><strong>Oficio Global:</strong> {{ contribuyente.fecha_oficio_global_favorable }}</li>
                          <li><strong>Publicación SAT:</strong> {{ contribuyente.fecha_publi_sat_favorable }}</li>
                          <li><strong>Publicación DOF:</strong> {{ contribuyente.fecha_publi_dof_favorable }}</li>
                        </ul>
                      </v-card>
                    </v-col>
                  </v-row>
                </template>

                <template v-else>
                  <p>Sin coincidencias encontradas.</p>
                </template>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
              <v-expansion-panel-header class="panel-header">
                SAT 74 Reducción de Multas
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <template v-if="data?.data?.sat74?.data.length">
                  <v-row dense v-for="(registro, index) in data.data.sat74.data" :key="index" class="mb-3">
                    <v-col cols="12">
                      <v-card outlined class="pa-4">
                        <p><strong>RFC:</strong> {{ registro.rfc }}</p>
                        <p><strong>Razón Social:</strong> {{ registro.razon_social }}</p>
                        <p><strong>Tipo de Persona:</strong> {{ registro.tipo_persona === 'm' ? 'Moral' : 'Física' }}</p>
                        <p><strong>Supuesto:</strong> {{ registro.supuesto }}</p>
                        <p><strong>Fecha de Autorización:</strong> {{ registro.fecha_autorizacion }}</p>
                        <p><strong>Monto Autorizado:</strong> ${{ Number(registro.monto).toLocaleString() }}</p>
                        <p><strong>Fecha de Publicación:</strong> {{ registro.fecha_publicacion }}</p>
                        <p><strong>Entidad Federativa:</strong> {{ registro.entidad_federativa }}</p>
                      </v-card>
                    </v-col>
                  </v-row>
                </template>

                <template v-else>
                  <p>Sin coincidencias encontradas.</p>
                </template>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
        <v-expansion-panel-header class="panel-header">
          VALIDACIÓN DE IDENTIFICACIÓN
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-expansion-panels multiple class="mt-8">
            <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
              <v-expansion-panel-header class="panel-header">
                Extracción de datos de ID
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div v-if="data?.data?.ineFrente?.data && data?.data?.ineReverso?.data">
                  <v-card outlined class="pa-4">
                    <v-row>
                      <v-col cols="12" md="6">
                        <h4 class="font-weight-bold mb-2">Información General</h4>
                        <p><strong>Nombre:</strong> {{ data?.data?.ineFrente?.data.ocr.nombre }}</p>
                        <p><strong>Apellidos:</strong> {{ data?.data?.ineFrente?.data.ocr.apellido_paterno }} {{ data?.data?.ineFrente?.data.ocr.apellido_materno }}</p>
                        <p><strong>Fecha de nacimiento:</strong> {{ data?.data?.ineFrente?.data.ocr.fecha_nacimiento }}</p>
                        <p><strong>Sexo:</strong> {{ data?.data?.ineFrente?.data.ocr.sexo }}</p>
                        <p><strong>CURP:</strong> {{ data?.data?.ineFrente?.data.ocr.curp }}</p>
                        <p><strong>Clave de Elector:</strong> {{ data?.data?.ineFrente?.data.ocr.clave }}</p>
                        <p><strong>Dirección:</strong> {{ data?.data?.ineFrente?.data.ocr.calle_numero }}, {{ data?.data?.ineFrente?.data.ocr.colonia }}, {{ data?.data?.ineFrente?.data.ocr.estado }} {{ data?.data?.ineFrente?.data.ocr.codigo_postal }}</p>
                        <p><strong>Municipio:</strong> {{ data?.data?.ineFrente?.data.ocr.municipio }}</p>
                        <p><strong>Sección:</strong> {{ data?.data?.ineFrente?.data.ocr.seccion }}</p>
                        <p><strong>Emisión:</strong> {{ data?.data?.ineFrente?.data.ocr.emision }}</p>
                        <p><strong>Vigencia:</strong> {{ data?.data?.ineFrente?.data.ocr.vigencia }}</p>
                      </v-col>

                      <v-col cols="12" md="6">
                        <h4 class="font-weight-bold mb-2">Validación Visual</h4>
                        <v-chip v-for="(val, key) in data?.data?.ineFrente?.data.figuras" :key="key" :color="val ? 'green' : 'red'" dark class="ma-1">
                          {{ key }}: {{ val ? 'Sí' : 'No' }}
                        </v-chip>

                        <v-divider class="my-4"></v-divider>

                        <h4 class="font-weight-bold mb-2">Datos del Reverso</h4>
                        <p><strong>Modelo:</strong> {{ data?.data?.ineReverso?.data.ocr.model }}</p>
                        <p><strong>MRZ:</strong> {{ data?.data?.ineReverso?.data.ocr.mrz }}</p>

                        <v-img
                          :src="data?.data?.ineReverso?.data.url_input"
                          contain
                          max-height="120"
                          class="mb-2"
                        ></v-img>
                        <v-img
                          :src="data?.data?.ineReverso?.data.url_output"
                          contain
                          max-height="120"
                        ></v-img>
                      </v-col>
                    </v-row>
                  </v-card>
                </div>
                <p v-else>Sin coincidencias encontradas.</p>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
              <v-expansion-panel-header class="panel-header">
                Validación INE (Lista Nominal)
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div v-if="data?.data?.listaNominal?.data?.length">
                  <v-card outlined class="pa-4">
                    <v-row>
                      <v-col cols="12" sm="6">
                        <p><strong>Estado:</strong> {{ data.data.listaNominal.data[0].estado }}</p>
                        <p>
                          <strong>¿Activa?</strong>
                          <v-chip :color="data.data.listaNominal.data[0].activa ? 'green' : 'red'" dark>
                            {{ data.data.listaNominal.data[0].activa ? 'Sí' : 'No' }}
                          </v-chip>
                        </p>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-alert type="info" dense outlined>
                          {{ data.data.listaNominal.data[0].information }}
                        </v-alert>
                      </v-col>
                    </v-row>

                    <v-divider class="my-4"></v-divider>

                    <div>
                      <h4 class="mb-2 font-weight-bold">Comentarios:</h4>
                      <v-list dense>
                        <v-list-item v-for="(comment, index) in data.data.listaNominal.data[0].comentarios" :key="index">
                          <v-list-item-icon>
                            <v-icon color="primary">mdi-comment-alert-outline</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title style="text-wrap: auto;">{{ comment }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </div>
                  </v-card>
                </div>
                <p v-else>Sin coincidencias encontradas.</p>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
              <v-expansion-panel-header class="panel-header">
                Geolocalización del Domicilio
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div v-if="data?.data?.geoData?.data?.items.length">
                  <v-card class="pa-4" outlined>
                    <v-row>
                      <v-col cols="12" md="6">
                        <p><strong>Dirección:</strong> {{ data.data.geoData.data.items[0].address.label }}</p>
                        <p><strong>Ciudad:</strong> {{ data.data.geoData.data.items[0].address.city }}</p>
                        <p><strong>Estado:</strong> {{ data.data.geoData.data.items[0].address.state }}</p>
                        <p><strong>Código Postal:</strong> {{ data.data.geoData.data.items[0].address.postalCode }}</p>
                        <p><strong>Coordenadas:</strong> {{ data.data.geoData.data.items[0].position.lat }}, {{ data.data.geoData.data.items[0].position.lng }}</p>
                      </v-col>

                      <v-col cols="12" md="6">
                        <iframe
                          :src="mapUrl"
                          width="100%"
                          height="250"
                          style="border-radius: 12px; border: none;"
                          allowfullscreen
                          loading="lazy"
                        ></iframe>
                      </v-col>
                    </v-row>
                  </v-card>
                </div>
                <p v-else>Sin coincidencias encontradas.</p>
              </v-expansion-panel-content>
            </v-expansion-panel>

          </v-expansion-panels>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
        <v-expansion-panel-header class="panel-header">
          ANTECEDENTES JUDICIALES
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <template v-if="data?.data?.getAntecedentesJudiciales?.data?.resultados?.length">
            <v-row dense v-for="(entidad, i) in data?.data?.getAntecedentesJudiciales?.data?.resultados" :key="i" class="mb-4">
              <v-col cols="12">
                <v-card outlined class="pa-4" style="overflow-y: scroll; max-height: 400px;">
                  <h4 class="text-primary mb-2">Entidad: {{ entidad.entidad }}</h4>

                  <v-divider class="my-2" />

                  <v-row v-for="(exp, j) in entidad.expedientes" :key="j" class="mb-4">
                    <v-col cols="12">
                      <v-card flat class="pa-3" color="grey lighten-4">
                        <p><strong>Expediente:</strong> {{ exp.expediente }}</p>
                        <p><strong>Actor:</strong> {{ exp.actor }}</p>
                        <p><strong>Demandado:</strong> {{ exp.demandado }}</p>
                        <p><strong>Juzgado:</strong> {{ exp.juzgado }}</p>
                        <p><strong>Tipo:</strong> {{ exp.tipo || 'No especificado' }}</p>
                        <p><strong>Fuero:</strong> {{ exp.fuero }}</p>
                        <p><strong>Fecha:</strong> {{ exp.fecha }}</p>

                        <v-expansion-panels multiple elevation="0" class="mt-2">
                          <v-expansion-panel>
                            <v-expansion-panel-header>Acuerdos</v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <ul>
                                <li v-for="(acuerdo, k) in exp.acuerdos" :key="k">
                                  <strong>{{ acuerdo.fecha }}:</strong> {{ acuerdo.acuerdo || 'Sin detalle del acuerdo' }}
                                </li>
                              </ul>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </template>

          <template v-else>
            <p>Sin antecedentes judiciales encontrados.</p>
          </template>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
        <v-expansion-panel-header class="panel-header">
          INFORMACIÓN LABORAL
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-expansion-panels multiple class="mt-8">
            <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
              <v-expansion-panel-header class="panel-header">
                Número de Seguro Social (NSS)
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-skeleton-loader
                  v-if="true"
                  type="article"
                  class="mb-4"
                ></v-skeleton-loader>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
              <v-expansion-panel-header class="panel-header">
                Historial Laboral
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-skeleton-loader
                  v-if="true"
                  type="article"
                  class="mb-4"
                ></v-skeleton-loader>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
              <v-expansion-panel-header class="panel-header">
                Crédito Infonavit
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-skeleton-loader
                  v-if="true"
                  type="article"
                  class="mb-4"
                ></v-skeleton-loader>
              </v-expansion-panel-content>
            </v-expansion-panel>

          </v-expansion-panels>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
        <v-expansion-panel-header class="panel-header">
          IDENTIDAD DIGITAL
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-expansion-panels multiple class="mt-8">
            <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
              <v-expansion-panel-header class="panel-header">
                Análisis y Perfilamiento de Datos de Email y Teléfono
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card outlined class="pa-4 mb-4">
                  <h4 class="font-weight-bold mb-2">📱 Teléfono</h4>
                  <p><strong>Número:</strong> {{ data?.data?.perfilamientoTelefono?.data?.number }}</p>
                  <p>
                    <strong>Válido:</strong>
                    <v-chip :color="data?.data?.perfilamientoTelefono?.data?.valid ? 'green' : 'red'" dark>{{ data?.data?.perfilamientoTelefono?.data?.valid ? 'Sí' : 'No' }}</v-chip>
                    <strong class="ml-4">Temporal:</strong>
                    <v-chip :color="data?.data?.perfilamientoTelefono?.data?.disposable ? 'orange' : 'grey'" dark>{{ data?.data?.perfilamientoTelefono?.data?.disposable ? 'Sí' : 'No' }}</v-chip>
                  </p>

                  <h5 class="mt-3 mb-2">Redes Registradas:</h5>
                  <v-chip
                    v-for="(value, platform) in data?.data?.perfilamientoTelefono?.data?.account_details"
                    :key="platform"
                    v-if="value && value.registered"
                    class="ma-1"
                    color="primary"
                    dark
                  >
                    {{ platform }}
                  </v-chip>
                </v-card>

                <v-card outlined class="pa-4">
                  <h4 class="font-weight-bold mb-2">✉️ Correo Electrónico</h4>
                  <p><strong>Email:</strong> {{ data?.data?.perfilamientoCorreo?.data?.email }}</p>
                  <p><strong>Entregable:</strong>
                    <v-chip :color="data?.data?.perfilamientoCorreo?.data?.deliverable ? 'green' : 'red'" dark>{{ data?.data?.perfilamientoCorreo?.data?.deliverable ? 'Sí' : 'No' }}</v-chip>
                  </p>

                  <h5 class="mt-3 mb-2">Dominio:</h5>
                  <p><strong>Dominio:</strong> {{ data?.data?.perfilamientoCorreo?.data?.domain_details?.domain }}</p>
                  <v-chip class="ma-1" v-if="data?.data?.perfilamientoCorreo?.data?.domain_details?.valid_mx" color="green" dark>MX válido</v-chip>
                  <v-chip class="ma-1" v-if="data?.data?.perfilamientoCorreo?.data?.domain_details?.spf_strict" color="green" dark>SPF estricto</v-chip>
                  <v-chip class="ma-1" v-if="data?.data?.perfilamientoCorreo?.data?.domain_details?.dmarc_enforced" color="green" dark>DMARC activo</v-chip>
                  <v-chip class="ma-1" v-if="data?.data?.perfilamientoCorreo?.data?.domain_details?.accept_all" color="orange" dark>Acepta todos</v-chip>

                  <h5 class="mt-4 mb-2">Cuentas Vinculadas:</h5>
                  <v-chip
                    v-for="(value, platform) in data?.data?.perfilamientoCorreo?.data?.account_details"
                    :key="platform"
                    v-if="value && value.registered"
                    class="ma-1"
                    color="blue"
                    dark
                  >
                    {{ platform }}
                  </v-chip>

                  <div v-if="data?.data?.perfilamientoCorreo?.data?.breach_details?.haveibeenpwned_listed" class="mt-4">
                    <v-alert type="error" dense outlined icon="mdi-alert">
                      ¡Este correo aparece en bases de datos filtradas!
                    </v-alert>
                  </div>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
              <v-expansion-panel-header class="panel-header">
                Enriquecimiento de datos
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card outlined class="pa-3">
                  <v-card-title class="subtitle-1 font-weight-bold">
                    Teléfonos encontrados
                  </v-card-title>

                  <v-card-text>
                    <v-list two-line dense>
                      <v-list-item
                        v-for="(phone, index) in data?.data?.enriquecimientoNombre?.data?.query?.phones"
                        :key="index"
                      >
                        <v-list-item-content>
                          <v-list-item-title>
                            📞 {{ phone.display_international || phone.display }}
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            Código País: +{{ phone.country_code }} <br>
                            Número: {{ phone.number }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
              <v-expansion-panel-header class="panel-header">
                Top 5 resultados en Google
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <template v-if="data?.data?.top5results?.data?.length">
                  <v-card
                    v-for="(result, index) in data?.data?.top5results?.data.slice(0, 5)"
                    :key="index"
                    outlined
                    class="mb-4 pa-4"
                  >
                    <v-row>
                      <v-col cols="12">
                        <a :href="result.link" target="_blank" class="text-primary font-weight-bold">
                          {{ result.title }}
                        </a>
                        <p class="text-subtitle-2 mb-1">{{ result.displayed_link }}</p>
                        <p>{{ result.snippet }}</p>

                        <!-- Rich snippet info (optional) -->
                        <div v-if="result.rich_snippet?.top?.attributes?.length">
                          <v-divider class="my-2" />
                          <p class="text-caption font-weight-bold mb-1">Detalles:</p>
                          <ul>
                            <li
                              v-for="(attr, i) in result.rich_snippet.top.attributes"
                              :key="'attr-' + i"
                            >
                              {{ attr.name }}: {{ attr.value }}
                            </li>
                          </ul>
                        </div>

                        <!-- Sitio relacionados (optional) -->
                        <div v-if="result.sitelinks?.inline?.length">
                          <v-divider class="my-2" />
                          <p class="text-caption font-weight-bold mb-1">Sitios relacionados:</p>
                          <ul>
                            <li
                              v-for="(link, i) in result.sitelinks.inline"
                              :key="'site-' + i"
                            >
                              <a :href="link.link" target="_blank">{{ link.title }}</a>
                            </li>
                          </ul>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card>
                </template>

                <template v-else>
                  <p>Sin coincidencias encontradas.</p>
                </template>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel elevation="2" class="mb-4" style="border-radius: 16px;">
              <v-expansion-panel-header class="panel-header">
                TOP 5 noticias en Google
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <template v-if="data?.data?.top5Noticias?.data?.length">
                  <v-card
                    v-for="(item, index) in data?.data?.top5Noticias?.data.slice(0, 5)"
                    :key="index"
                    class="mb-4 pa-3"
                    variant="outlined"
                    >
                    <v-row>
                      <v-col cols="3" v-if="item.thumbnail">
                        <v-img
                          :src="item.thumbnail"
                          alt="thumbnail"
                          height="80"
                          cover
                          class="rounded"
                        />
                      </v-col>

                      <v-col :cols="item.thumbnail ? 9 : 12">
                        <a
                          :href="item.link"
                          target="_blank"
                          rel="noopener"
                          class="text-primary font-weight-medium text-subtitle-1"
                        >
                          {{ item.title }}
                        </a>

                        <div class="text-caption mt-1">
                          <span class="font-weight-bold">{{ item.source }}</span>
                          <span v-if="item.date"> &bull; {{ item.date }}</span>
                        </div>

                        <div class="mt-2 text-body-2">
                          {{ item.snippet }}
                        </div>
                      </v-col>
                    </v-row>
                  </v-card>
                </template>

                <template v-else>
                  <p>Sin coincidencias encontradas.</p>
                </template>
              </v-expansion-panel-content>
            </v-expansion-panel>

          </v-expansion-panels>
        </v-expansion-panel-content>
      </v-expansion-panel>

    </v-expansion-panels>
  </v-container>
</template>

<script>
import moment from "moment";

export default {
  name: 'ReportePersonaMoral',
  data() {
    return {
      data: {},
      comentarios: '',
      loading: false,
      analysis: '',
      isLoading: false,
    };
  },
  methods: {
    formatDate: function (date) {
      if (this.selectLanguage === "sp") {
        moment.locale("es");
      } else {
        moment.locale("en");
      }
      let newDate = moment(date);
      let formattedDate = newDate.format("MMMM D, YYYY");
      return formattedDate;
    },
    getReport() {
      this.isLoading = true;
      DB.get(`${URI}/api/v1/${this.selectLanguage}/check/reportPerson/${this.$route.params.idReport}`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : "",
        },
      }).then((response) => {
        this.isLoading = false;
        this.data = response.data.data;
      }).catch((error) => {
        this.isLoading = false;
        this.mixError(error.response?.data?.message || "Ocurrió un error");
        if (error.response.data.code) {
          this.$router.push("/welcome").catch(() => {});
        }
      });
    },
    downloadCertificate(base64Data, fileName = 'certificado') {
      // Decodificar base64
      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      // Crear un blob
      const blob = new Blob([byteArray], { type: 'application/x-x509-ca-cert' });

      // Crear un enlace temporal
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `${fileName}.cer`;
      link.click();

      // Limpiar memoria
      URL.revokeObjectURL(link.href);
    },
    async analyzeWithAI() {
      this.loading = true;
      const payload = {
        sReportId: this.$route.params.idReport,
      };

      try {
        const response = await DB.post(`${URI}/api/v1/${this.selectLanguage}/check/analyzeReport`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          },
        });
        this.analysis = response.data.data;
      } catch (error) {
        this.analysis = "Ocurrió un error al obtener el análisis.";
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.getReport();
  },
  computed: {
    selectLanguage: function () {
      return this.$store.state.language;
    },
    hasAnyBlacklistMatch() {
      const b = this.data?.data?.listasNegras?.data || {};
      return (
        b.has_crimelist_match ||
        b.has_pep_match ||
        b.has_watchlist_match ||
        (b.has_sanction_match && b.result_payload.sanctionlist_entries.length)
      );
    },
    mapUrl() {
      const pos = this.data?.data?.geoData?.data?.items[0].position;
      return `https://www.openstreetmap.org/export/embed.html?bbox=${pos.lng - 0.005},${pos.lat - 0.005},${pos.lng + 0.005},${pos.lat + 0.005}&layer=mapnik&marker=${pos.lat},${pos.lng}`;
    }
  },
  watch: {
    selectLanguage: function () {
      if (this.selectLanguage) {
        this.texts = FILE.landing[this.selectLanguage];
      }
    },
  },
};
</script>

<style>
  .panel-header {
    background-color: black;
    color: white;
    font-family: 'montserrat-bold';
    border-radius: 16px;
  }
  .panel-header .v-expansion-panel-header__icon i {
    color: white !important;
  }
</style>
